
export const getEditableTexts = ({items: productModelItems}) => productModelItems
    // skip items that are not valid text areas
    .filter(item => (
        item.type === "BoundedTextItem" && // check text areas only
        item._visible && // use only visible items
        !item._locked && // use only user-editable items
        item._font && // use areas with fonts only
        item._textRectangle // use areas with a known area on the product
    ))
    // set relevant text data to be returned
    .map(item => ({
        id: item.id,
        name: item._name,
        surfaceName: item._parentContainer.parentComponent._name,
        left: Math.round(item._textRectangle._left + item._transform._translateX),
        top: Math.round(item._textRectangle._top + item._transform._translateY),
        width: Math.round(item._textRectangle._width),
        height: Math.round(item._textRectangle._height),
        text: item._text,
        font: {
            name: item._font?.postScriptName,
            size: item._font?._size || 0,
            allCaps: !!item._font?._allCaps,
        },
    }));
